import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IForcePasswordUpdateParams {
  systemUserIds?: string[];
}

export interface IForcePasswordUpdateResult extends IResult {
}

export class ForcePasswordUpdateRequest extends Request<IForcePasswordUpdateParams, IForcePasswordUpdateResult> {
  constructor(params: IForcePasswordUpdateParams) {
    super('forcePasswordUpdate', params);
  }
}
